exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body,html{height:100%;width:100%;padding:0;margin:0;overflow:hidden;background-color:#f6f6f6}.index__frame--XQLfJ,iframe{border:none}.index__languageSwitcher--2oNIc{display:flex;align-items:center;justify-content:center;margin:15px 0}.index__button--2wpxM{margin-right:10px}", ""]);

// exports
exports.locals = {
	"frame": "index__frame--XQLfJ",
	"languageSwitcher": "index__languageSwitcher--2oNIc",
	"button": "index__button--2wpxM"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?modules&minimize=true&localIdentName=[path][name]__[local]--[hash:base64:5]!./index.css
// module id = 98
// module chunks = 0